(function() {
    jQuery(document).ready(function () {
        window.avatarMenu = new cAvatar(".c-avatar-container");
        window.exploreButton = cExploreButton.init('.c-explore-button-container');
        window.mobileLeftMenu = new MobileLeftMenu(".c-mobile-left-menu");
        window.searchBoxDesktop = new cSearchBox(".s-header-search-wrapper .c-search-container");
        window.searchBoxMobile = new cSearchBox(".s-search-container-mobile .c-search-container");

        document.documentElement.style.setProperty('--scrollbar-width', `${getScrollbarWidth()}px`);

        $(".c-close-header-section button").on("click", function(){
            $("body").removeClass("body-no-scroll");
            $("html").removeClass("html-modal-open");
        });

        $(".js-scrolls-widget-mobile").on("click", function(){
            if ( lastWindowState === 'small' && $("#v2BookingWidgetContainer").length ){
                $("html, body").animate({
                    scrollTop: ($("#v2BookingWidgetContainer").offset().top - 1 )
                }, 500);
            }
        });

        $(document).on('focus', '.c-input-control input, .c-textarea-control textarea', function() {
            $(this).parents('.c-common-control').addClass('focused');
        });
        
        $(document).on('blur', '.c-input-control input, .c-textarea-control textarea', function() {
            $(this).parents('.c-common-control').removeClass('focused');
        });
        
        $(document).on('keyup change', '.c-input-control input, .c-textarea-control textarea', function() {
            if ($(this).val().length === 0) {
                $(this).parents('.c-common-control').addClass('empty');
            } else {
                $(this).parents('.c-common-control').removeClass('empty');
            }
        });	        

        if ( $("body.single-activity").length > 0 ) {
            const faqSummary = $('.faq-summary-answer');
            if ( $(faqSummary).length ){
                const faqSummaryAnswerText = $(faqSummary).find(".faq-summary-answer-text");
                const faqSummaryTextReadMore = $(faqSummary).find("a.c-mobile-only");
                const lineHeight = $(faqSummaryAnswerText).css("line-height").replace('px', '');
                const totalLines = $(faqSummaryAnswerText)[0].scrollHeight / lineHeight;
                const maxLines = $(faqSummaryAnswerText).data("max-lines-read-more-button") || 7;

                if (  totalLines > maxLines && $(window).width() > 1024) {
                    faqSummaryTextReadMore.removeClass('c-mobile-only');
                }        
            }

            if ( $(".c-tab-navigation.single-activity").length > 0 ){
                window.footerTabNavigation = new TabNavigation('.c-tab-navigation.single-activity');
            }

            if ( $(".media-gallery").length > 0 ){
                window.activityDetailMainSlider = new cSlider(".media-gallery");
            }

            if ( $(".widget-area").length > 0 ){
                window.stickySidebar = new StickySidebar('.widget-area', {
                    topSpacing: 80,
                    bottomSpacing: 17,
                    containerSelector: '.element-container',
                    innerWrapperSelector: '.inner-wrapper-sticky',
                    minWidth: 1024,
                });
            }

            if ( $("#collapse-traveler-photos").length > 0 ){
                $("#collapse-traveler-photos .traveller__image__container").on("click", function( e ){
                    if ( typeof tmPhotoGallery !== 'undefined' && tmPhotoGallery !== null ){
                        tmPhotoGallery.showPhotoGalleryModal( 'traveler-photos', $(this).data('id') );
                    }
                });
            }

            if ( $(".c-traveler__slider").length > 0 && typeof $(".c-traveler__slider").comparisonTableSlickSlider === 'function' ){
                $(".c-traveler__slider").comparisonTableSlickSlider();
            }
            
            
        }

        if ( $('ul[data-total-items-ul]').length > 0 ){
            $('ul[data-total-items-ul]').each(function () {
                const $ul = $(this);
                const totalVisible = parseInt($ul.data('total-items-ul'), 10);
                const $items = $ul.find('li');
                
                if ($items.length > totalVisible) {
                    // Hide extra items
                    $items.slice(totalVisible).addClass('c-hidden');
        
                    // Create "See more" link
                    const hiddenCount = $items.length - totalVisible;
                    const $moreLink = $(`<a href="#" class="see-more-button no-color"><span>See ${hiddenCount} more</span>`);
        
                    $moreLink.insertAfter($ul);
        
                    // Handle click
                    $moreLink.on('click', function (e) {
                        e.preventDefault();
                        $ul.find('.c-hidden').removeClass('c-hidden');
                        $(this).remove();
                    });
                }
            });        
        }

        $(".c-icon-bottom-values span[data-modal-target]").on("click", function (e) {
            e.stopPropagation();
        })

        if ( $(".c-multi-step-radio").length > 0 ){
            jQuery(".c-multi-step-radio").on( "click", ".c-multi-step-radio-item", function () {
                $(this).siblings(".c-multi-step-radio-item.c-multi-step-radio-item-selected").find(".radiobtn input[type=radio]").removeAttr("checked");
                $(this).siblings(".c-multi-step-radio-item.c-multi-step-radio-item-selected").removeClass("c-multi-step-radio-item-selected");
                $(this).addClass("c-multi-step-radio-item-selected");
                $(this).find(".radiobtn input[type=radio]").prop("checked","checked");
            });
        }

        if ( $("#langauge-currency").length > 0 ){
            $("#langauge-currency .c-tabs-item").on("click", function () {
                $(this).siblings(".c-tabs-item.c-tabs-item-active").removeClass("c-tabs-item-active");
                $(this).addClass("c-tabs-item-active");

                tab_id = '#langauge-currency-' + $(this).attr("data-tab-item-key");
                $(".langauge-currency-tab .c-tab-navigation-content").addClass("c-hidden");
                $(tab_id).removeClass("c-hidden");
            });
        }
        $(document).on("click", ".simple-weather__day", function () {
            let $temp = $(this).find(".simple-weather__temp");
            let text = $temp.text().trim();

            $temp.fadeOut(300, function () {
                if (text.endsWith("F") || text.endsWith("°F")) {
                    // Fahrenheit → Celsius
                    let f = parseFloat(text);
                    let c = Math.round((f - 32) * 5 / 9);
                    $temp.text(c + "°C");
                } else {
                    // Celsius → Fahrenheit
                    let c = parseFloat(text);
                    let f = Math.round((c * 9 / 5) + 32);
                    $temp.text(f + "°F");
                }
                $temp.fadeIn(300);
            });
        });

        jQuery(document).on('tmModal_open_#c-auth-modal', function () {                    
            if ( $(".tm-account-email-div").length ){
                $(".tm-account-email-div input").focus();
            }
        });        
            
    });
})();

function getScrollbarWidth() {
  // Temporary div create karo
  const scrollDiv = document.createElement("div");

  // CSS apply karo to force scrollbar
  scrollDiv.style.width = "100px";
  scrollDiv.style.height = "100px";
  scrollDiv.style.overflow = "scroll"; // force scrollbars
  scrollDiv.style.position = "absolute";
  scrollDiv.style.top = "-9999px"; // hide it

  document.body.appendChild(scrollDiv);

  // offsetWidth - clientWidth = scrollbar width
  const scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;

  document.body.removeChild(scrollDiv);

  return scrollbarWidth;
}

const width = getScrollbarWidth();